// Nottingham has no basket controls until a populated basket is rendered.
// Import the unchanged basket tools when their controls become available.
const config = document.querySelector('script[data-edit-module][data-delivery-module]');
if (config) {
  let deliveryTask;
  let editTask;
  let editReady = false;
  const loadDelivery = () => deliveryTask ||= import(config.dataset.deliveryModule);
  const loadEdit = () => editTask ||= import(config.dataset.editModule).then(() => { editReady = true; });
  const observeControls = () => {
    if (config.dataset.deliveryModule && document.querySelector('welch-cart-delivery')) {
      loadDelivery().catch(error => console.error('Basket delivery could not load.', error));
    }
    if (document.querySelector('[data-welch-edit], [data-welch-replace]')) {
      loadEdit().catch(error => console.error('Basket editing could not load.', error));
    }
  };
  const observer = new MutationObserver(observeControls);
  observer.observe(document.body, { childList: true, subtree: true });
  observeControls();
  // Preserve the first edit click if a newly rendered basket is used before import completes.
  document.addEventListener('click', async event => {
    const trigger = event.target instanceof Element && event.target.closest('[data-welch-edit], [data-welch-replace]');
    if (!trigger || editReady) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    trigger.disabled = true;
    try {
      await loadEdit();
      trigger.disabled = false;
      if (trigger.isConnected) trigger.click();
    } catch (error) {
      trigger.disabled = false;
      let message = trigger.parentElement.querySelector('[data-cart-load-error]');
      if (!message) {
        message = document.createElement('p');
        message.dataset.cartLoadError = '';
        message.setAttribute('role', 'alert');
        trigger.parentElement.append(message);
      }
      message.textContent = 'Basket tools could not load. Please reload the page and try again.';
      console.error(error);
    }
  }, true);
}
